exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".input[data-v-68a1752a]{font-size:.8125rem;width:100%;border:none;line-height:1.5;background-color:#fff;position:relative;padding:.5rem}.input[data-v-68a1752a]:focus{border:#3098db}", ""]);

// exports
